
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lhO3J", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $c4sKh = parcelRequire("c4sKh");


var $3ikmX = parcelRequire("3ikmX");


var $3gadb = parcelRequire("3gadb");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $8aF6s = parcelRequire("8aF6s");


var $6wrL8 = parcelRequire("6wrL8");


var $6PAZq = parcelRequire("6PAZq");

const $3b73839d1efa4dca$var$buttonAndBadgeStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'row',
    marginRight: 'space.negative.150'
});
const $3b73839d1efa4dca$var$badgeNudgerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    bottom: '10px',
    right: '10px',
    width: 'max-content'
});
const $3b73839d1efa4dca$var$tooltipListStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.200',
    marginBottom: 'space.100'
});
const $3b73839d1efa4dca$var$i18n = (0, $h82at.defineMessages)({
    statsigOverrides: {
        id: "app-navigation.feature-flag-logo.statsig-overrides",
        defaultMessage: "Statsig overrides:"
    }
});
const $3b73839d1efa4dca$export$860cdfdedb4344a5 = (t0)=>{
    const $ = (0, $frIzR.c)(25);
    const { featureGateOverrides: featureGateOverrides } = t0;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const hide = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).HIDE_FEATURE_FLAG_ICON);
    if (hide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p",
            color: "color.text.inverse"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $3b73839d1efa4dca$var$i18n.statsigOverrides));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== featureGateOverrides.gates) {
        t2 = Object.entries(featureGateOverrides.gates).map($3b73839d1efa4dca$var$_temp);
        $[1] = featureGateOverrides.gates;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== featureGateOverrides.configs) {
        t3 = Object.entries(featureGateOverrides.configs).map($3b73839d1efa4dca$var$_temp2);
        $[3] = featureGateOverrides.configs;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            as: "ul",
            xcss: $3b73839d1efa4dca$var$tooltipListStyles
        }, t2, t3));
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== showModal) {
        t5 = ()=>{
            showModal((0, $6wrL8.DevToolsDialog), {});
        };
        $[8] = showModal;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ikmX))), {
            label: "Statsig overrides"
        });
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6PAZq.ConfigurationButton), {
            onClick: t5
        }, t6);
        $[11] = t5;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t4
        }, t7);
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== featureGateOverrides.gates) {
        t9 = Object.keys(featureGateOverrides.gates);
        $[16] = featureGateOverrides.gates;
        $[17] = t9;
    } else t9 = $[17];
    const t10 = t9.length;
    let t11;
    if ($[18] !== featureGateOverrides.configs) {
        t11 = Object.keys(featureGateOverrides.configs);
        $[18] = featureGateOverrides.configs;
        $[19] = t11;
    } else t11 = $[19];
    const t12 = t10 + t11.length;
    let t13;
    if ($[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3b73839d1efa4dca$var$badgeNudgerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
            appearance: "important"
        }, t12));
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== t13 || $[23] !== t8) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $3b73839d1efa4dca$var$buttonAndBadgeStyles
        }, t8, t13);
        $[22] = t13;
        $[23] = t8;
        $[24] = t14;
    } else t14 = $[24];
    return t14;
};
function $3b73839d1efa4dca$var$_temp(t0) {
    const [name, value] = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        key: name
    }, name, " (", JSON.stringify(value), ")");
}
function $3b73839d1efa4dca$var$_temp2(t0) {
    const [name_0, value_0] = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
        key: name_0
    }, name_0, " (", JSON.stringify(value_0), ")");
}
module.exports["FeatureFlagLogo"] = $3b73839d1efa4dca$export$860cdfdedb4344a5;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("dZpm6"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("dZpm6"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("ddmQY"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("dZpm6", function(module, exports) {

let $a2f4a3eba407266a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a2f4a3eba407266a$var$load("lkOIY"),
    $a2f4a3eba407266a$var$load("dRpV3"),
    $a2f4a3eba407266a$var$load("6wr18"),
    $a2f4a3eba407266a$var$load("1UnnS"),
    $a2f4a3eba407266a$var$load("ffEVr"),
    $a2f4a3eba407266a$var$load("kHOMt"),
    $a2f4a3eba407266a$var$load("hhss7"),
    $a2f4a3eba407266a$var$load("7EorR"),
    $a2f4a3eba407266a$var$load("Wowvf"),
    $a2f4a3eba407266a$var$load("4Nzvy"),
    $a2f4a3eba407266a$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("ddmQY", function(module, exports) {

let $99ee3773125bddc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99ee3773125bddc9$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("6PAZq", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $c7f6301e4003b18e$var$configurationButtonStyle = null; //eslint-disable-next-line  @atlaskit/design-system/no-html-button
const $c7f6301e4003b18e$export$d135bcb304f7cb12 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $gMc0m.default)([
            "_11q71gly _2rko1rr0 _19it1j28 _4t3i1f4h _1bsb1f4h _syaz1tmw _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke _1q5t1r31 _nt751r31 _1ohyglyw _49pcglyw _1r9x1o36 _1hvw1o36"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ConfigurationButton"] = $c7f6301e4003b18e$export$d135bcb304f7cb12;

});


//# sourceMappingURL=FeatureFlagLogo.30ac0c8c.js.map
